import * as React from 'react';
import b_ from 'b_';
import LocalizedImage from 'components/LocalizedImage';

const iphoneImage = require.context('./static/img/iphone');
const macbookImage = require.context('./static/img/macbook');

import './index.scss';

const b = b_.with('main-page-previews');

const Previews = () => {
  return (
    <div className={b()} data-testid={'main-page-previews'}>
      <LocalizedImage
        path={macbookImage}
        alt="investments"
        className={b('preview', { laptop: true })}
      />
      <LocalizedImage
        path={iphoneImage}
        alt="investments"
        className={b('preview', { phone: true })}
      />
    </div>
  );
};

export default Previews;
